function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useRef, useEffect } from "react";
import classNamesMaker from "classnames";
import { node, arrayOf, element } from "prop-types";
import { Button, BUTTON_VARIANT } from "#library/components/Button";
import IconArrowDown from "#library/assets/icons/jds_arrowDown.svg";
import { ModalLink } from "#library/components/MenuBar/Link/ModalLink";
import styles from "./accordion.module.css";
export var Accordion = function Accordion(_ref) {
  var children = _ref.children,
    items = _ref.items;
  var listRef = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    listStyle = _useState4[0],
    setListStyle = _useState4[1];
  useEffect(function () {
    var currentList = listRef.current;
    if (currentList) {
      setListStyle(_objectSpread({}, isOpen && {
        maxHeight: "".concat(currentList.scrollHeight, "px")
      }));
    }
  }, [isOpen, listRef]);
  var isAnyAccordionItemSelected = function isAnyAccordionItemSelected() {
    return React.Children.toArray(items).some(function (_ref2) {
      var props = _ref2.props;
      // eslint-disable-next-line react/prop-types
      return props === null || props === void 0 ? void 0 : props.selected;
    });
  };
  var listClassNames = classNamesMaker(styles["jds-Accordion__list"], isOpen && styles["jds-Accordion__list--isOpen"]);
  var buttonClassNames = classNamesMaker(styles["jds-Accordion__button"], _defineProperty({}, styles["jds-Accordion__button--selected"], isAnyAccordionItemSelected()));
  return /*#__PURE__*/React.createElement("div", {
    className: styles["jds-Accordion"]
  }, /*#__PURE__*/React.createElement(Button, {
    className: buttonClassNames,
    variant: BUTTON_VARIANT.NAKED,
    icon: IconArrowDown,
    iconOnRight: true,
    minor: true,
    isFullWidth: true,
    onClick: function onClick() {
      return setIsOpen(!isOpen);
    }
  }, children), /*#__PURE__*/React.createElement("ul", {
    ref: listRef,
    style: listStyle,
    className: listClassNames
  }, items.map(function (item, index) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      React.createElement("li", {
        key: index,
        className: styles["jds-Accordion__item"]
      }, /*#__PURE__*/React.createElement(ModalLink, item.props))
    );
  })));
};
Accordion.propTypes = {
  children: node.isRequired,
  items: arrayOf(element).isRequired
};